// extracted by mini-css-extract-plugin
export default {"img":"TrustedBy_img__ZfVsn","trusted":"TrustedBy_trusted__F3Fx1","text":"TrustedBy_text__xn9WS","imgChild":"TrustedBy_imgChild__mhAs7"};